import HOUSETYPES from './houseTypes';

export default class HouseTypeFactory {
  static createInstance(type) {
    const houseTypeCreator = HOUSETYPES[type];
    const houseType = houseTypeCreator ? new houseTypeCreator() : null;

    return houseType;
  }
}
